import type { TranslationMessages } from '../../types';

export const rating: TranslationMessages = {
  title: 'Đánh giá của bạn',
  subtitle: 'Phản hồi và đánh giá của khách hàng về hiệu suất của bạn',
  loading: 'Đang tải đánh giá...',
  rate_your_experience: 'Đánh giá trải nghiệm của bạn',
  how_was_the_service: 'Dịch vụ như thế nào?',
  service_quality: 'Chất lượng dịch vụ',
  friendliness: 'Thân thiện',
  professionalism: 'Chuyên nghiệp',
  speed: 'Tốc độ',
  knowledge: 'Kiến thức',
  overall: 'Tổng thể',
  add_comment: 'Thêm bình luận (tùy chọn)',
  comment_placeholder: 'Hãy cho chúng tôi biết về trải nghiệm của bạn...',
  submit_rating: 'Gửi đánh giá',
  rating_submitted: 'Đánh giá đã gửi',
  thank_you_for_rating: 'Cảm ơn bạn đã đánh giá dịch vụ của chúng tôi!',
  rating_success: 'Đánh giá của bạn đã được gửi thành công.',
  anonymous_rating: 'Gửi ẩn danh',
  rating_required: 'Vui lòng cung cấp đánh giá',
  one_star: 'Kém',
  two_stars: 'Trung bình',
  three_stars: 'Tốt',
  four_stars: 'Rất tốt',
  five_stars: 'Tuyệt vời',
  rating_distribution: 'Phân phối đánh giá',
  rating_distribution_desc:
    'Phân tích tất cả các đánh giá của khách hàng về bạn',
  average_rating: 'Đánh giá trung bình',
  total_ratings: 'Tổng số đánh giá',
  this_week: 'tuần này',
  verified: 'Đã xác minh',
  verified_percent: '% đã xác minh',
  high_ratings: 'Đánh giá cao',
  high_ratings_desc: 'Đánh giá 4+ sao',
  filters_sorting: 'Bộ lọc & Sắp xếp',
  filter_by: 'Lọc theo:',
  all_ratings: 'Tất cả đánh giá',
  verified_only: 'Chỉ đã xác minh',
  unverified_only: 'Chỉ chưa xác minh',
  high_ratings_filter: 'Đánh giá cao (4+)',
  low_ratings_filter: 'Đánh giá thấp (2-)',
  sort_by: 'Sắp xếp theo:',
  sort_date: 'Ngày (Mới nhất)',
  sort_rating: 'Đánh giá (Cao nhất)',
  sort_category: 'Danh mục',
  customer_ratings: 'Đánh giá của khách hàng',
  customer_ratings_desc: 'Phản hồi và đánh giá gần đây của khách hàng',
  verified_by_manager: 'Được quản lý xác minh vào',
  failed_load: 'Không thể tải đánh giá',
  category_customer_service: 'Dịch vụ khách hàng',
  category_speed: 'Tốc độ',
  category_product_knowledge: 'Kiến thức sản phẩm',
};
